import {Component,Inject, Input, EventEmitter, Output} from 'ng-metadata/core';
import { ChangeLangService } from './changeLang.service';
import {getAttributesMap, getRtlLanguages, getVid} from '../../appConfig/appConfigForward';
//your imports go here
import {PrimolyticsService,beacon} from '../../analytics/primolytics.service';
import {JwtUtilService} from '../../security/jwtUtil.service';
import {UserSessionManagerService} from '../../security/userSessionManager.service';
import { ConfigurationUtil } from '../../nddUtils/configurationUtil.service';
import {AnalyticsUtils} from "../../nddUtils/analyticsUtils.service";
const isEqual = require('lodash/isEqual');

@Component({
    selector: 'prm-change-lang',
    templateUrl: 'components/infra/lang/change-lang.html',
})

export class PrmChangeLang{
    @Input() private labelType:string;
    @Input() public isMainMenu:string; 
    @Input() public isMyAccount:string;

    @Output() private changeLangEvent: EventEmitter<Object>= new EventEmitter();

    private _selectedLanguage: string;
    private languages:string[];
    private attributesMap = getAttributesMap();
    private vid = getVid();
    private rtlLanguages = getRtlLanguages();

    /* input fields */

    constructor(private changeLangService: ChangeLangService,
                @Inject('I18nService') private i18nService,
                private jwtUtilService: JwtUtilService,
                private userSessionManagerService: UserSessionManagerService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('topBarIcons') private topBarIcons,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private primolyticsService: PrimolyticsService,
                private configurationUtil: ConfigurationUtil,
                private analyticsUtils: AnalyticsUtils,
    ) {
        this.changeLangService.getPersonalSettingsFromDBPromise(this.vid).then(res => {
            this.selectedLanguage = this.isUserLangSet(res) && !this.isMainMenu ? this.extractLangFromResponse(res) : i18nService.getLanguage(); 
        });
        this.languages = this.attributesMap.interfaceLanguageOptions.split(',');
        if (!this.isMyAccount){   //to solve part of PRM-46459: When changing lang in my account, the lang param will show the interface language and not the user's default lang as before
            this.changeLangService.addLangParamToUrl(this.selectedLanguage);
        }
    }
    private extractLangFromResponse(res: ng.IHttpPromiseCallbackArg<unknown>): string {
        return this.configurationUtil.isSuprima() ? res.data.language : res.data.interfaceLanguage;
    }
    private isUserLangSet(res: ng.IHttpPromiseCallbackArg<unknown>) : boolean{
        return res && res.data && ((this.configurationUtil.isSuprima() && res.data.language) || (!this.configurationUtil.isSuprima() && res.data.interfaceLanguage))
    }

    get selectedLanguage() {
        return this.changeLangService.selectedLanguage;
    }

    set selectedLanguage(selectedLanguage) {
        this.changeLangService.selectedLanguage = selectedLanguage;
    }

    /* tslint:disable  no-unused-variable  */
    private getLabelType() {
        return this.labelType;
    }


    @beacon({'p':'general', 'op':'changeLanguage'})
    private changeLanguage() {
        if(!this.isMainMenu){
            this.changeLangService.addLangParamToUrl(this.selectedLanguage);
            if (this.jwtUtilService.isSignedIn()){
                let updateUserLanguagePromise = this.changeLangService.updateUserLanguage(this.vid,this.selectedLanguage);
                updateUserLanguagePromise.then((response)=>this.successAction(response));
            }
        }
        if(!isEqual(this.selectedLanguage, this.$state.params['lang'])) {
            this.sendAnalytics(this.selectedLanguage);
        }
        return this.i18nService.setLanguage(this.selectedLanguage).then(()=> {
            this.changeLangEvent.emit({lang: this.selectedLanguage });
            // the timeout have been added to fix this: PRM-35152
            this.$timeout(()=>{
                return this.$state.go(this.$state.current, {lang: this.selectedLanguage}, {reload: true});
            })
        });

    }
    /* tslint:enable  no-unused-variable  */

    private successAction(response) {
        this.userSessionManagerService.syncJwtWithTabs(response.data);
        this.jwtUtilService.storeJwt(response.data);
    }

    private async sendAnalytics(language) {
        let  payload = await this.getAnalyticsPayload(language);
        this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.CHANGE_LANGUAGE, payload);
    }

    private async getAnalyticsPayload(language: any) {
        const translation = await this.$translate("mypref.language.option." + language);
        return{
            'Language' : translation,
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/lang/changeLang.directive.ts